import apiHeader from '@/helpers/apiHeader';

const advanceSearchCharacteristicService = {
    search(params) {
        return apiHeader.post('navbar/search-by-characteristic/search', params);
    },
}

export default advanceSearchCharacteristicService;